module.exports = __webpack_public_path__ + "static/media/2t.25fa81a5.png";